import React from "react";
import "./PreFooter.css";
import logo from "../../Assets/logo_new.png";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";

const PreFooter = () => {
  return (
    <footer className="Footer">
      <div className="container">
        <div className="row">
          {/* Left Section - Logo & Description */}
          <div className="col-lg-3 col-md-6 mt-5">
            <div className="Footer-social">
              <a href="#" className="Footer-social-btn">
                <FaFacebookF />
              </a>
              <a href="#" className="Footer-social-btn">
                <FaLinkedinIn />
              </a>
              <a href="#" className="Footer-social-btn">
                <FaTwitter />
              </a>
              <a href="#" className="Footer-social-btn">
                <FaYoutube />
              </a>
            </div>
            <div className="Footer-brand">
              <img
                src={logo}
                alt="HrHub Logo"
                className="Footer-logo"
                style={{ height: "100px", marginTop: "20px" }}
              />
            </div>
          </div>

          {/* Contact Section */}
          <div className="col-lg-3 col-md-6 mt-5 ">
            <h4 className="Footer-heading">Reach Us</h4>
            <ul className="Footer-list">
              <li>
                <a
                  href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  Plot No, 64, Vanagaram-Ambattur Rd, Ayanambakkam, Ambattur
                  Industrial Estate, Chennai, Tamil Nadu 600095
                </a>
              </li>
            </ul>
          </div>

          {/* Support Section */}
          <div className="col-lg-3 col-md-6 mt-5 ">
            <h4 className="Footer-heading">Get In Touch </h4>
            <ul className="Footer-list">
              <li>
                <span className="Footer-icon">
                  <i className="fa fa-mobile-alt" aria-hidden="true"></i>
                </span>
                <a
                  href="tel:+91-44-40401066"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  +91-44-40401066
                </a>
              </li>

              <li>
                <span className="Footer-icon">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </span>
                <a
                  href="mailto:infochennai@apollohospitals.com"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  infochennai@apollohospitals.com
                </a>
              </li>
              <li>
                <span className="Footer-icon">
                  <i className="fa fa-globe" aria-hidden="true"></i>
                </span>
                <a
                  href="https://www.tnpyampicon2025.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  www.tnpyampicon2025.com
                </a>
              </li>
            </ul>
          </div>

          {/* Information Section */}
          <div className="col-lg-3 col-md-6 mt-5 ">
            <h4 className="Footer-heading">Quick Links</h4>
            <ul className="Footer-list">
              <a
                href="/contacts"
                style={{ textDecoration: "none", color: "white" }}
              >
                {" "}
                <li>Contacts</li>
              </a>
              <a
                href="/privacypolicy"
                style={{ textDecoration: "none", color: "white" }}
              >
                {" "}
                <li>Privacy Policy</li>
              </a>
              <a
                href="/terms"
                style={{ textDecoration: "none", color: "white" }}
              >
                <li>Terms & Conditions</li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PreFooter;
